import type { RecReviewData } from '../useDashboardController';

export type RecReviewDataWithRoomTypes = RecReviewData;

export enum ColumnSources {
	FORECAST = 'Forecast',
	INVENTORY = 'Inventory',
	KPI = 'KPI',
	PICKUP = 'Pickup',
	RATES = 'Rates',
	COMPETITORS = 'Competitors',
	ROOM_TYPE_RATES = 'Room Type Rates',
}

export const DEFAULT_COL_WIDTH = 110;
